module.exports = __webpack_public_path__ + "img/cabin_w002.12ef920e.jpg";